export default __webpack_public_path__ + "static/media/left-team.0743a407.png";